import React from 'react'
import Loader from '../components/widgets/Loader'

export const withLoader = (BaseComponent) => (props) =>
  props.isLoading ? <Loader /> : <BaseComponent {...props} />
